"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pathgen = void 0;
var pathGen_1 = require("./pathGen/pathGen");
Object.defineProperty(exports, "pathgen", { enumerable: true, get: function () { return pathGen_1.pathgen; } });
